<script>
    import { computed,onMounted,ref,reactive, nextTick } from 'vue'
    import Recaptcha from '../../../common/components/Recaptcha.vue'
    import { useForm } from 'vee-validate';
    import * as yup from 'yup';

    export default {
      components: {
        Recaptcha,
      },
      props: {
        dataOptin: {
          type: String,
          default: '',
        },
      },
      setup(props){
        const recaptcha = ref(null)
        const optIn = ref(null)
        const context =  ref('competitor');
        const isPosted =  ref(false);
        const captchaError =  ref(false);
        const form = reactive({
          lastname: '',
          firstname: '',
          phone: '',
          email: '',
          messagelong: '',
          mention: '',
          captcha: '',
          acceptance: '',
        })

        const { values, errors, defineField, validate } = useForm({
          validationSchema: yup.object({
            lastname: yup.string().required('Le nom est requis'),
            firstname: yup.string().required('Le prénom est requis'),
            email: yup.string().email('L\'email est invalide').required('L\'email est requis'),
              }),
            phone: yup
              .string()
              .matches(/^(0|\+33)[0-9]{9}$/, 'Le numéro de téléphone est invalide'),
        });
        const [lastname, lastnameAttrs] = defineField('lastname', {
          validateOnMount: false,
          validateOnChange: true,
          validateOnBlur: true,
        });
        const [firstname, firstnameAttrs] = defineField('firstname', {
          validateOnMount: false,
          validateOnChange: true,
          validateOnBlur: true,
        });
        const [email, emailAttrs] = defineField('email', {
          validateOnMount: false,
          validateOnChange: true,
          validateOnBlur: true,
        });
        const [phone, phoneAttrs] = defineField('phone', {
          validateOnMount: false,
          validateOnChange: true,
          validateOnBlur: true,
        });
        const formEl =  ref(null);
        const showForm = computed(() => {
          return (context.value === 'competitor' || context.value === 'change') && !isPosted.value
        });

        const showPhone = computed(() => {
          return context.value === 'owner' || context.value === 'tenant'
        });

        const showSuccess = computed(() => {
          return isPosted.value && (context.value === 'competitor' || context.value === 'change')
        });


        /** @param {Object<string, string>} formData  */
        function updateDatalayer(formData) {
          // First let's format the form_name
          formData.form_name = formData.form_name
            .trim()
            .replace(/["+?!]/g, '')
            .replace(/[#_', ]/g, '_')
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')

          // Then push it to the data layer
          window.dataLayer.push(formData)
        };
        function onCaptchaExpired() {
          recaptcha.value.reset()
          captchaError.value = true
        };
        function onCaptchaVerified(token) {
          recaptcha.value.reset()
          form.captcha = token
          submitForm()
        };
        function checkRecaptcha() {
          captchaError.value = false
          recaptcha.value.execute()
        };
        const submitForm = () => {
        validate()
        .then((result) => {
          if (result.valid && form.captcha.length > 0) {
            sendForm()
          }
          else{
            console.log("Validation failed", result.errors);
          }
        })
        .catch((e) => {
          console.log(e)
        })

    };
        function sendForm() {
          form.lastname = lastname
          form.firstname = firstname
          form.email = email
          if(phone.value !== undefined && phone.value !== null && phone.value !== ""){
            form.phone = phone
          }
          for (let [key, value] of Object.entries(form)) {
            let input = formEl.value.querySelector(`[name='${key.toLowerCase()}']`)
            if (input) {
              switch (key) {
                case 'mention':
                  input.value = value ? optIn.value : ''
                  break
                case 'acceptance':
                  input.value = 'Envoyer mon email'
                  break
                default:
                  input.value = value
                  break
              }
            }
          }

          // Before building the datalayer check if we are on the correct node
          const articleDataset = document.querySelector('article').dataset

          // If so, send the informations to the datalayer
          if (
            'contentType' in articleDataset &&
            articleDataset.contentType == 'Déménagement'
          ) {
            const formData = {
              event: 'form_confirmation',
              form_type: 'Contact_demenagement',
              form_name: document.querySelector(
                '.article__header h1.title.title--1'
              ).textContent,
            }

            updateDatalayer(formData)
          }

          formEl.value.submit()
        };

        const setContext = (newContext) => {
          context.value = newContext
        }

        function setFocusState(event) {
          event.target.parentNode.classList.add('form__field--active')
        };
        function setBlurState(event) {
          if (event.target.value === '')
            event.target.parentNode.classList.remove('form__field--active')
        };
        onMounted(async () => {
          await nextTick()
          optIn.value = props.dataOptin ? JSON.parse(props.dataOptin) : ''
          formEl.value =  document.getElementsByClassName("webform-submission-form")[0];
          isPosted.value = formEl.value.querySelector('.webform-confirmation') !== null
        })

        return {
          setBlurState,
          setFocusState,
          setContext,
          sendForm,
          checkRecaptcha,
          onCaptchaVerified,
          submitForm,
          onCaptchaExpired,
          updateDatalayer,
          form,
          context,
          captchaError,
          isPosted,
          showForm,
          showPhone,
          showSuccess,
          lastname,
          firstname,
          email,
          phone,
          values,
          errors,
          recaptcha
        }
      }
    }
</script>
<style lang="sass">
@import ../../../common/styles/settings
@import ../../../common/styles/mixins
@import _article-form.sass
</style>
